export default __webpack_public_path__ + "static/media/slider_1_4.54102608.jpg";